import api from '../api';

/**
 * Fetches banners from the server.
 *
 * @return {Promise<Object>} - The banners data from the API.
 * @throws {Error} - If the request fails.
 */
const getBanners = async () => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/banners/data`;

  try {
    const response = await api.get(endpoint);

    return response.data;
  } catch (error) {
    console.error('Error fetching banners:', error);
    throw error;
  }
};

export default getBanners;
